import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'No sé meditar, ¿esto es para mí?',
    a: 'Solo dale play. Los audios hacen el trabajo por ti.'
  }, {
    q: '¿Cuánto tiempo al día necesito?',
    a: 'La meditación clave de la mañana toma minutos y te da energía para todo el día.'
  }, {
    q: 'Soy escéptico, ¿funciona?',
    a: 'Andy llegó sin creer en nada de esto. Hoy factura online. Los resultados hablan solos.'
  }, {
    q: '¿Esto es religioso?',
    a: 'No. Es neurociencia. Si tienes fe, la profundiza. Si eres escéptico, los resultados te convencen.'
  }, {
    q: '¿Cómo recibo todo?',
    a: 'En menos de 2 minutos recibes un email con acceso inmediato a todo. Sin esperas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-dark-100" data-id="element-54">
      <div className="max-w-[680px] mx-auto" data-id="element-55">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-56">
          Preguntas Frecuentes
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-body" data-id="element-57">
          Preguntas Frecuentes
        </h2>

        <div className="border-t border-divider" data-id="element-58">
          {faqs.map((faq, i) => <div key={i} className={`border-b border-divider transition-colors duration-300 ${openIndex === i ? 'bg-dark-200' : 'bg-dark-100'}`} data-id="element-59">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-60">
                <span className="font-bold text-base text-body pr-4" data-id="element-61">
                  {faq.q}
                </span>
                {openIndex === i ? <MinusIcon className="w-5 h-5 text-gold shrink-0" data-id="element-62" /> : <PlusIcon className="w-5 h-5 text-gold shrink-0" data-id="element-63" />}
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-64">
                <p className="text-sub text-sm leading-relaxed" data-id="element-65">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}